export default {
  presenter: 'iliushin',
  title: 'Hacking 101',
  subtitle: 'začátečníci',
  text: `
Workshop pro zacatecniki v oblasti bezpecnosti, behem workshopu dokazete utocit na server
nekolika zpusoby a taky si vyzkousete utocit na IoT prvky.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/iliushin-hacking-101.js